export const environment = {
  production: false,
  name: 'qa',
  storageEncryptionKey: 'bnKOBxVxVsn4DRpB5IGNFsPF+ckxVHkuU9U44GudFFjE5MlvsV2vT6qY4mCaoTeM',
  storageEncryptionIv: 'O+rD5Vw4x6BHuk59PriDtp+Ma6v1XdjzxwKZPdtvX28=',
  googleAuthUrl: 'https://qapurchaseapi.petpooja.com/api/web/authentication/v1/auth/google',
  authentication: {
    url: 'https://qapurchaseapi.petpooja.com',
    path: '/api/web/authentication/v1/'
  },
  notification: {
    url: 'https://qapurchaseapi.petpooja.com',
    path: '/api/web/notification/v1/'
  },
  dashboard: {
    url: 'https://qapurchaseapi.petpooja.com',
    path: '/api/web/dashboard/v1/'
  },
  invoice: {
    bypassUrl: 'https://qapurchaseapi.petpooja.com',
    bypassPath: '/api/web/invoice/v1/',
    url: 'https://qapurchaseapi.petpooja.com',
    path: '/api/web/invoice/v1/',
    pathV2: '/api/web/invoice/v2/',
    bypassPathV2: '/api/web/invoice/v2/'
  },
  payment: {
    url: 'https://qapurchaseapi.petpooja.com',
    path: '/api/web/payment/v1/',
    bypassUrl: 'https://qapurchaseapi.petpooja.com',
    bypassPath: '/api/web/payment/v1/',
  },
  metadata: {
    url: 'https://qapurchaseapi.petpooja.com',
    path: '/api/web/metadata/v1/'
  },
  pushtopetpooja: {
    url: 'https://qapurchaseapi.petpooja.com',
    path: '/api/web/push-to-petpooja/v1/'
  },
  tally: {
    url: 'https://qapurchaseapi.petpooja.com',
    path: '/api/web/tally/v1/'
  },
  sentry: {
    dsn: 'https://c65d926eaae8c8aab5f1ac6ee3975d10@o4506522915373056.ingest.us.sentry.io/4509717283536896', // Add your Sentry DSN here for QA
    environment: 'qa',
    tracesSampleRate: 0.3,
    enabled: false // Set to true when you have your DSN
  },
  hyperpureTrustedOrigin: 'https://dev.hyperpure.com',
  hyperpureIframeUrl: 'https://dev.hyperpure.com/in/Init',
  swiggyAssureOrigin: 'https://runnerappha-env027.in-west.swig.gy',
  swiggyAssureIframeUrl: 'https://runnerappha-env027.in-west.swig.gy/assure/partner-checkout',
  //swiggyAssureOrigin: 'https://staging-assure.swiggy.com',
  //swiggyAssureIframeUrl: 'https://staging-assure.swiggy.com/assure/partner-checkout',
  deliveritCheckoutUrl: 'https://customer-qa.deliverit.net.in/checkout',
  checkoutEnabledForDeliverit: true
};
